var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-clinics"},_vm._l((_vm.value),function(clinic,index){return _c('clinic-phone-selector',{key:clinic.id,attrs:{"value":clinic},on:{"input":function($event){return _vm.updateClinic($event, index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }